import { useQuery } from 'react-query';

import { UserTransferApi } from 'api/UserTransferApi';

export const useUserTransferLinkQuery = (isEnabled: boolean) => {
  return useQuery('user-transfer-link', UserTransferApi.fetchUserTransferLink, {
    enabled: isEnabled,
    retry: false,
  });
};
